<h2 mat-dialog-title>{{ 'PERFORMANCE.GRADES' | translate }}</h2>
<mat-dialog-content style="max-height: 100%; background-color: var(--mat-app-background-color);"   >    
    
@if (GameRankingDetails) {
<div style="overflow-x:auto;">
    <table >
        <tr>
            <th colspan="2" style="text-align: left;">
                <img style="height: 64px;"  [src]="('../../assets/img/' + (ShowTeam === 'Home' ? GameRankingDetails.HomeTeam.team.SmallIconFileName : GameRankingDetails.AwayTeam.team.SmallIconFileName)).replace('//','/').toLowerCase()" style="height: 32px;">
                <div>
                    {{ShowTeam === 'Home' ? GameRankingDetails.HomeTeam.team.Name : GameRankingDetails.AwayTeam.team.Name }}
                </div>
            </th>


            @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
            {
                <th class="rotate"> <div><span>{{scout.ScoutName }} </span></div></th>
            }

        </tr>
       <!--  <tr  style="font-family: Rubik,Verdana; font-size: x-small; border: 1px solid black  ;">
            <th></th>
            <th>{{ "PLAYER.GOALTENDERS" | translate | uppercase }}</th>

            @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
            {
                <td></td>
            }

        </tr> -->
    

       
            @for(player of this.Players; track $index)
            {
                @if(player.PlayerView.PositionId==1)
                {
                    <tr>
                        <td>{{player.PlayerView.JerseyNo}}</td>
                        <td class="playername-cell">{{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}</td>

                        @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
                        {
                        <td style="text-align: right;">
                            <div [ngClass]="this.GetPlayerGradeClass(player.PlayerView.LifelineScoutingId, this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway)">
                                {{this.getGrade(player.PlayerView.LifelineScoutingId,   this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway) }}
                            </div>     
                            </td>
                        
                    }
                    </tr>
                }
            } 
        
        <tr>
            <th></th>
            <th>{{ "PLAYER.DEFENDERS" | translate | uppercase }}</th>

            @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
            {
                <td></td>
            }
        </tr>
        @for(player of this.Players; track $index)
        {
            @if(player.PlayerView.PositionId==2)
            {
                <tr>
                    <td>{{player.PlayerView.JerseyNo}}</td>
                    <td class="playername-cell">{{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}</td>

                    @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
                    {
                      <td style="text-align: right;">
                        <div [ngClass]="this.GetPlayerGradeClass(player.PlayerView.LifelineScoutingId, this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway)">
                            {{this.getGrade(player.PlayerView.LifelineScoutingId, this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway) }}
                        </div>     
                        </td>
                    }

                </tr>
            }
        }
         <tr>
            <th></th>
            <th>{{ "PLAYER.FORWARDS" | translate | uppercase }}</th>

            @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
            {
                <td></td>
            }
        </tr>
        @for(player of this.Players; track $index)
        {
            @if(player.PlayerView.PositionId>2)
            {
                <tr>
                    <td>{{player.PlayerView.JerseyNo}}</td>
                    <td class="playername-cell">{{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}</td>

                    @for(scout of this.GameRankingDetails.PlayerRankings; track $index)
                    {
                       <td style="text-align: right;">
                            <div [ngClass]="this.GetPlayerGradeClass(player.PlayerView.LifelineScoutingId, this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway)">
                                {{this.getGrade(player.PlayerView.LifelineScoutingId, this.ShowTeam === 'Home' ? scout.GamePlayerRankingsHome : scout.GamePlayerRankingsAway) }}
                            </div>                                             
                        </td>
                    }

                </tr>
            }
        }
    </table>
</div>
}

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>CLOSE</button>

    
    
</mat-dialog-actions>
